import React, { useState, useMemo } from 'react';
import { Button } from '@this/src/components/shared/ui/inputs/button';
import type Trip from '@this/domain/trip/trip2';
import MemberInfoModal from './member_info_modal';

interface Props {
  trip: Trip;
}

export const MemberInfoButton: React.FC<Props> = ({ trip }) => {
  const [open, setOpen] = useState(false);

  const { organizationId, userId } = useMemo(() => {
    const traveler = trip?.currentOrder?.orderItems?.[0]?.travelerInformations?.[0]?.user;
    return {
      organizationId: traveler?.organization?.id ?? null,
      userId: traveler?.id ?? null
    };
  }, [trip]);

  if (!trip?.currentOrder) return null;

  return (
    <>
      <Button type="button" onClick={() => setOpen(true)}>
        社員情報
      </Button>
      <MemberInfoModal
        show={open}
        organizationId={organizationId}
        userId={userId}
        onClose={() => setOpen(false)}
      />
    </>
  );
};
